export function getTonberryUrl(characterName: string) {
  const safeCharaName = characterName.replace(/[^\w\s]/g, "").replace(/\s+/g, "-").toLowerCase()
  return `https://www.tonberrytroupe.com/infographics/${safeCharaName}`
}
